var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1295 19.077L23.165 23.2211L19.0208 22.1845C18.7278 22.1122 18.4183 22.1537 18.1548 22.3006C16.5643 23.194 14.771 23.664 12.9467 23.6654C7.06692 23.6654 2.28418 18.8815 2.28418 13.0029C2.28418 7.12426 7.06692 2.34033 12.9467 2.34033C18.8265 2.34033 23.6093 7.12426 23.6093 13.0029C23.6076 14.8266 23.1381 16.6194 22.2456 18.2097C22.0971 18.4732 22.0555 18.7837 22.1295 19.077Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4635 18.9076C25.4026 17.0807 25.8932 15.0565 25.8947 13.0024C25.8947 5.86379 20.0861 0.0551758 12.9474 0.0551758C5.80866 0.0551758 0 5.86379 0 13.0024C0 20.1411 5.80866 25.9497 12.9474 25.9497C14.9978 25.9497 17.0293 25.4565 18.8537 24.5196L24.4329 25.9144C24.6299 25.964 24.8365 25.9616 25.0323 25.9073C25.2281 25.8531 25.4065 25.7488 25.5499 25.6048C25.6937 25.4611 25.7977 25.2825 25.852 25.0866C25.9062 24.8906 25.9088 24.6839 25.8594 24.4867L24.4635 18.9076ZM22.0706 19.0371L23.0993 23.1543L18.982 22.1244C18.691 22.0525 18.3835 22.0937 18.1216 22.2397C16.5414 23.1274 14.7598 23.5943 12.9474 23.5957C7.10575 23.5957 2.35407 18.8428 2.35407 13.0024C2.35407 7.16205 7.10575 2.40922 12.9474 2.40922C18.789 2.40922 23.5407 7.16205 23.5407 13.0024C23.5391 14.8143 23.0726 16.5954 22.1859 18.1755C22.0383 18.4372 21.997 18.7457 22.0706 19.0371Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.4900d6374615f5ae5826b46305760b25.svg";
export { ForwardRef as ReactComponent };